import { ControlledAutocomplete, ControlledSelect } from '@if/mui'
import { Box, Chip, MenuItem, Stack, Typography } from '@mui/material'
import { BannerDto } from '@src/data/types/BannerSchema'
import { EMerchantReportFrequency } from '@src/data/types/Constants'
import { JSX, memo, useMemo } from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<BannerDto>
}

const BannerReportConfigPanel = ({ control }: Props) => {
  const { t } = useTranslation()
  const options = useMemo<JSX.Element[]>(
    () => [
      <MenuItem key={EMerchantReportFrequency.daily} value={EMerchantReportFrequency.daily}>
        {t('common.eMerchantReportFrequency.daily')}
      </MenuItem>,
      <MenuItem key={EMerchantReportFrequency.weekly} value={EMerchantReportFrequency.weekly}>
        {t('common.eMerchantReportFrequency.weekly')}
      </MenuItem>,
      <MenuItem key={EMerchantReportFrequency.monthly} value={EMerchantReportFrequency.monthly}>
        {t('common.eMerchantReportFrequency.monthly')}
      </MenuItem>,
    ],
    [t],
  )
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t('banner.bannerReportsConfiguration')}
      </Typography>
      <Stack gap={2}>
        <ControlledSelect
          name="reportGenerationFrequency"
          control={control}
          label={t('merchant.reports.frequency')}
          emptyOptionLabel={t('common.eMerchantReportFrequency.never')}
          emptyOptionValue="none"
          options={options}
          fullWidth
        />
        <ControlledAutocomplete
          name="reportRecipientsEmailList"
          control={control}
          label={t('merchant.reports.recipients')}
          multiple
          freeSolo
          autoSelect
          options={[]}
          renderValue={(tagValue, getTagsProps) =>
            tagValue.map((option, index) => (
              <Chip {...getTagsProps({ index })} key={option as string} label={option as string} />
            ))
          }
        />
      </Stack>
    </Box>
  )
}
export default memo(BannerReportConfigPanel)
